import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=3c1d27e6&scoped=true&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"
import style0 from "./initial.vue?vue&type=style&index=0&id=3c1d27e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1d27e6",
  null
  
)

export default component.exports